
import { lazy, Suspense } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { DashboardHeader } from "@/components/DashboardHeader";
import { ContentLayout } from "@/components/layout/ContentLayout";
import { DebugPanel } from "@/components/DebugPanel";

const PipelineDashboard = lazy(() => import("@/components/dashboard/PipelineDashboard").then(m => ({ default: m.PipelineDashboard })));

const Index = () => {
  return (
    <SidebarProvider defaultOpen={false}>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <DashboardHeader />
        <ContentLayout width="wide">
          <Suspense fallback={null}>
            <PipelineDashboard />
          </Suspense>
        </ContentLayout>
      </div>
      </div>
      <DebugPanel
        layoutTemplate="dashboard"
        pageName="Dashboard (Index)"
      />
    </SidebarProvider>
  );
};

export default Index;
